

import Vue from 'vue';
import * as GlossStore from '@/store/search/form/glossStore';

import GlossQueryField from './GlossQueryField.vue'

export default Vue.extend ({
	components: { GlossQueryField },
	name: 'GlossSearch',
	props: {
		msg: String,
		src : String
	},

	data: () => ({
		debug: false,
		showQuery : false,
	}),

	methods : {
		resetQuery: GlossStore.actions.resetGlossQuery
	},
	computed : {
		settings: GlossStore.get.settings,
		gloss_fields() { return GlossStore.get.settings()?.gloss_fields },
		query_from_store() { return GlossStore.getState().gloss_query },
		query_cql_from_store() { return GlossStore.getState().gloss_query_cql },
	},
})

